module.exports = __webpack_public_path__ + "media/images/skullLogo-d0690fab91f2dfb8b19378fd212ba620.png";